export default "__VITE_ASSET__bd117e15__"